import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

export const mutation = gql`
  mutation SaveSuperchargerTextConsent(
    $gameId: Int!
    $marketingConsent: Boolean
    $roundConsent: Boolean
    $path: String
    $smsConsentCopyVersion: String
  ) {
    saveSuperchargerTextConsent(
      gameId: $gameId
      marketingConsent: $marketingConsent
      roundConsent: $roundConsent
      path: $path
      smsConsentCopyVersion: $smsConsentCopyVersion
    )
  }
`;

// The texting boxes after paying (wb-notify-service's
// Supercharger::Enrollment::ConsentSaver): each checked box records the
// caller's consent and texts its confirmation from the host's number, which
// also confirms her number. Returns the enrollment JSON.
export function useSaveSuperchargerTextConsent() {
  const [mutate, { loading, error }] = useMutation(mutation);

  const saveSuperchargerTextConsent = ({
    gameId,
    marketingConsent,
    roundConsent,
    path,
    smsConsentCopyVersion,
  }) =>
    mutate({
      variables: {
        gameId,
        marketingConsent,
        roundConsent,
        path,
        smsConsentCopyVersion,
      },
    });

  return { saveSuperchargerTextConsent, loading, error };
}
